import { createRouter, RouterProvider } from "@tanstack/react-router"
import { routeTree } from "./routeTree.gen"
import queryClient from "./queryClient"
import { useAuth } from "@clerk/clerk-react"

// https://github.com/TanStack/router/discussions/1119

// Create a new router instance
const router = createRouter({
    routeTree,
    context: { queryClient, auth: undefined },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}


export default function Router() {
    const auth = useAuth()
    return <RouterProvider router={router} context={{ queryClient, auth }} />;
}
